// styles
import { chartDashboardBoxStyle, chartDashboardType01Style } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledWorkingManpower = styled.div`
  ${chartDashboardBoxStyle}
  ${chartDashboardType01Style}
`;
